<h2 mat-dialog-title>انتخاب موقعیت مکانی</h2>

<div>
    <p>برای انتخاب موقعیت روی نقشه کلیک کنید.</p>
    <div style="height: 400px;" *ngIf="options" class="col p-0" leaflet [leafletOptions]="options"
        (leafletClick)="leafletClick($event)" [leafletLayers]="layers">
    </div>
</div>

<div mat-dialog-actions style=" display:-webkit-flex;
    display:-webkit-box;
    display:-moz-flex;
    display:-moz-box;
    display:-ms-flexbox;
    display:flex;; justify-content: flex-end;">
    <button mat-button [mat-dialog-close]>بستن</button>
    <button mat-flat-button color="primary" [mat-dialog-close]="selectedLocation">ثبت موقعیت</button>
</div>
